var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgClose = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 64,
    viewBox: "0 0 69 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#373D40",
    strokeLinecap: "square",
    strokeWidth: 7,
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 57.377,
    y1: 1.457,
    y2: 53.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    x2: 56,
    y1: -2,
    y2: 56,
    transform: "rotate(-90 29.5 27)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close.e07db6c8.svg";
export { ForwardRef as ReactComponent };